import PropTypes from 'prop-types';
import React from 'react';

// material-ui
import { makeStyles, useTheme } from '@material-ui/styles';
import { Box, Drawer, useMediaQuery } from '@material-ui/core';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import { BrowserView, MobileView } from 'react-device-detect';

// project imports
import MenuList from './MenuList';
import { Logo } from './../../../ui-component/Logo';
import { drawerWidth, navBackgroundColor } from './../../../store/constant';

// style constant
const useStyles = makeStyles((theme) => ({
    drawer: {
        [theme.breakpoints.up('md')]: {
            width: 20,
            flexShrink: 0
        }
    },
    drawerPaper: {
        width: drawerWidth,
        background: navBackgroundColor,
        color: '#ffffff',
        minHeight: '100vh',
        top: 0,
        [theme.breakpoints.up('md')]: {
            top: 0
        },
        '& .MuiListItemButton-root': {
            color: '#ffffff',
            '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.12)',
                color: '#ffffff',
                '& .MuiListItemIcon-root': { color: '#ffffff' }
            },
            '&.Mui-selected': {
                backgroundColor: 'rgba(255, 255, 255, 0.18)',
                color: '#ffffff',
                '& .MuiListItemIcon-root': { color: '#ffffff' }
            }
        },
        '& .MuiListItemIcon-root': { color: '#ffffff' },
        '& .MuiListItemText-primary': { color: '#ffffff' },
        '& .MuiTypography-root': { color: '#ffffff' },
        '& .MuiDivider-root': { borderColor: 'rgba(255, 255, 255, 0.25)' },
        '& .logo-sidebar img': { filter: 'brightness(0) invert(1)' }
    },
    logoContainer: {
        padding: '20px 16px',
        borderBottom: '1px solid rgba(255, 255, 255, 0.12)',
        minHeight: 64
    },
    ScrollHeight: {
        height: 'calc(100vh - 64px)',
        paddingLeft: '16px',
        paddingRight: '16px',
        [theme.breakpoints.down('sm')]: {
            height: 'calc(100vh - 56px)'
        }
    },
    boxContainer: {
        display: 'flex',
        padding: '16px',
        marginLeft: 'auto',
        marginRight: 'auto'
    }
}));

//-----------------------|| SIDEBAR DRAWER ||-----------------------//

const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
    const classes = useStyles();
    const theme = useTheme();
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));

    const drawer = (
        <React.Fragment>
            <div style={{ marginTop: 10, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Logo style={{ width: '100%', height: 'auto' }} />
            </div>
            <BrowserView>
                <PerfectScrollbar component="div" className={classes.ScrollHeight}>
                    <MenuList />
                </PerfectScrollbar>
            </BrowserView>
            <MobileView>
                <Box sx={{ px: 2 }}>
                    <MenuList />
                </Box>
            </MobileView>
        </React.Fragment>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <nav className={classes.drawer} aria-label="mailbox folders">
            <Drawer
                container={container}
                variant={matchUpMd ? 'persistent' : 'temporary'}
                anchor="left"
                open={drawerOpen}
                onClose={drawerToggle}
                classes={{
                    paper: classes.drawerPaper
                }}
                ModalProps={{ keepMounted: true }}
                color="inherit"
            >
                {drawer}
            </Drawer>
        </nav>
    );
};

Sidebar.propTypes = {
    drawerOpen: PropTypes.bool,
    drawerToggle: PropTypes.func,
    window: PropTypes.object
};

export default Sidebar;
